var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{attrs:{"id":"dashboard"}},[_c('b-header'),_c('grey-banner'),_c('settings-sidebar'),_c('aside',{attrs:{"id":"settings-right"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }